import './NewUserProgramForm.css'
import { Button } from '@mui/material'
import { v4 as uuid } from 'uuid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

export default function NewUserProgramForm({ addUserProgram }) {

    const handleSubmit = (e) => {
        e.preventDefault()
        const data = new FormData(e.currentTarget);
        const programName = data.get('programname')
        const exercise = {
            id: uuid(),
            name: '',
            description: '',
            instructions: '',
            metricType: 0,
            splitCategory: programName,
            isCategory: false,
            folder: '',
            link: '',
            thumbnail: '',
            idx: 0
        }
        addUserProgram(exercise)
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    // size='small'
                    required
                    fullWidth
                    id="programname"
                    label="Programnavn"
                    name="programname"
                    autoComplete="programname"
                    autoFocus
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Legg til
                </Button>
            </Box>
        </Box>
    )
}